<template>
  <div class="box">
    <div class="paper-type-container">
      <span style="margin-right: 10px">纸张类型:</span>
      <el-select
        v-model="paperType"
        placeholder="请选择纸张类型"
        size="mini"
        style="width: 140px; height: 32px"
        @change="changePaperType"
      >
        <el-option
          v-for="item in paperTypeList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
        ></el-option>
      </el-select>
      <span style="margin: 0 10px">宽高(mm):</span>
      <input
        class="width-height-input"
        type="text"
        :disabled="paperTypeState != 4"
        v-model.number="paperStyle.width"
        @change="changePaperStyle"
      />
      <span @click="test"> × </span>
      <input
        class="width-height-input"
        type="text"
        :disabled="paperTypeState != 4"
        v-model.number="paperStyle.height"
        @change="changePaperStyle"
      />
    </div>
    <div
      :style="{
        width: paperStyle.width + 'mm',
        height: paperStyle.height - 1 + 'mm',
      }"
      class="paper-container"
      :class="{
        paperTypeOther: paperTypeState == 4 || paperTypeState == 3,
      }"
    >
      <!-- 页边距 -->
      <div class="left-line" :style="{ left: pageSetLeft + 'mm' }"></div>
      <div class="right-line" :style="{ right: pageSetRight + 'mm' }"></div>
      <div class="top-line" :style="{ top: pageSetTop + 'mm' }"></div>
      <div class="bottom-line" :style="{ bottom: pageSetBottom + 'mm' }"></div>

      <div
        id="PrintContainer"
        :class="{
          paperType2: paperTypeState == 2,
          mask:
            (!!elementSetting.selectedBasePrintElement ||
              !!elementSetting.selectedTablePrintElement) &&
            setting,
        }"
        ref="printContainer"
        :style="{
          width: paperStyle.width + 'mm',
          height: paperStyle.height - 1 + 'mm',
        }"
        @click="setting = false"
      ></div>
    </div>
    <div style="display: none">{{ maxTableWidth }}</div>
  </div>
</template>
  
<script>
import { mapState, mapGetters } from "vuex";
import initElementTypeProvider from "@/utils/hiprint";
import { updateTemplateContentById } from "@/api";
import templates from "@/templates";

export default {
  name: "VuePrint",
  data() {
    return {
      hiprintTemplate: null,
      paperType: "二等分",
      paperTypeState: 2,
      paperStyle: {
        width: 241,
        height: 140,
      },
      paperTypeList: [
        {
          name: "A4",
          width: 210,
          height: 297,
          receipt: false,
          paperTypeState: 1,
        },
        {
          name: "一等分",
          width: 241,
          height: 280,
          receipt: false,
          paperTypeState: 2,
        },
        {
          name: "二等分",
          width: 241,
          height: 140,
          receipt: false,
          paperTypeState: 2,
        },
        {
          name: "三等分",
          width: 241,
          height: 93,
          receipt: false,
          paperTypeState: 2,
        },
        {
          name: "110mm(小票)",
          width: 110,
          height: 140,
          receipt: true,
          paperTypeState: 3,
        },
        {
          name: "80mm(小票)",
          width: 80,
          height: 140,
          receipt: true,
          paperTypeState: 3,
        },
        {
          name: "76mm(小票)",
          width: 76,
          height: 140,
          receipt: true,
          paperTypeState: 3,
        },
        {
          name: "58mm(小票)",
          width: 58,
          height: 140,
          receipt: true,
          paperTypeState: 3,
        },
        {
          name: "自定义",
          paperTypeState: 4,
        },
      ],
      receipt: false,
      elementSetting: elementSetting,

      data2: {
        billNo: "INV202310001",
        comegoName: "张三贸易公司",
        businessTime: "2023-10-01 14:30:00",
        address: "北京市朝阳区某某路123号",
        contacter: "李四",
        phone: "13800138000",
        detailVoList: [
          {
            seq: 1,
            storeName: "北京仓库",
            code: "P001",
            name: "商品A",
            specs: "规格A",
            unitName: "件",
            quantity: 10,
            price: 100,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 2,
            storeName: "上海仓库",
            code: "P002",
            name: "商品B",
            specs: "规格B",
            unitName: "箱",
            quantity: 5,
            price: 200,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 3,
            storeName: "广州仓库",
            code: "P003",
            name: "商品C",
            specs: "规格C",
            unitName: "盒",
            quantity: 20,
            price: 50,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 4,
            storeName: "深圳仓库",
            code: "P004",
            name: "商品D",
            specs: "规格D",
            unitName: "包",
            quantity: 15,
            price: 80,
            totalPrice: 1200,
            remarks: "无",
          },
          {
            seq: 5,
            storeName: "成都仓库",
            code: "P005",
            name: "商品E",
            specs: "规格E",
            unitName: "桶",
            quantity: 8,
            price: 150,
            totalPrice: 1200,
            remarks: "无",
          },
          {
            seq: 1,
            storeName: "北京仓库",
            code: "P001",
            name: "商品A",
            specs: "规格A",
            unitName: "件",
            quantity: 10,
            price: 100,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 2,
            storeName: "上海仓库",
            code: "P002",
            name: "商品B",
            specs: "规格B",
            unitName: "箱",
            quantity: 5,
            price: 200,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 3,
            storeName: "广州仓库",
            code: "P003",
            name: "商品C",
            specs: "规格C",
            unitName: "盒",
            quantity: 20,
            price: 50,
            totalPrice: 1000,
            remarks: "无",
          },
          {
            seq: 4,
            storeName: "深圳仓库",
            code: "P004",
            name: "商品D",
            specs: "规格D",
            unitName: "包",
            quantity: 15,
            price: 80,
            totalPrice: 1200,
            remarks: "无",
          },
          {
            seq: 5,
            storeName: "成都仓库",
            code: "P005",
            name: "商品E",
            specs: "规格E",
            unitName: "桶",
            quantity: 8,
            price: 150,
            totalPrice: 1200,
            remarks: "无",
          },
        ],
        amountDebtTotal: 5000,
        amountPayable: 2000,
        amountPaid: 1500,
        amountDebt: 500,
        remarks: "请尽快安排发货",
        createUserName: "王五",
      },
      setting: false,
    };
  },

  computed: {
    ...mapState([
      "printElementTypeGroup",
      "printStatus",
      "template",
      "templateStatus",
      "column",
      "footerFormatter",
      "pageTop",
      "pageLeft",
      "pageRight",
      "pageBottom",
      "MyOffsetX",
      "MyOffsetY",
    ]),
    ...mapGetters(["sourceUrl"]),
    paperFooterCanntOn() {
      let paperFooterCanntOn = [
        /*{top,bottom} */
      ];
      let top;
      let height;
      let findCanntInsertStartIndex, findCanntInsertEndIndex, t;
      this.hiprintTemplate.editingPanel.printElements.forEach((item) => {
        top = item.options.top;
        height = item.options.height;
        findCanntInsertStartIndex = -1;
        // findCanntInsertStartIndex = paperFooterCanntOn.findIndex((item) => {
        //   return top > item.bottom;
        // });
        paperFooterCanntOn.forEach((item, index) => {
          if (top > item.bottom) {
            findCanntInsertStartIndex = index;
          }
        });
        findCanntInsertStartIndex++;
        findCanntInsertEndIndex = -1;
        // findCanntInsertEndIndex = paperFooterCanntOn.findIndex((item) => {
        //   return top + height > item.top;
        // });
        paperFooterCanntOn.forEach((item, index) => {
          if (top + height > item.top) {
            findCanntInsertEndIndex = index;
          }
        });
        findCanntInsertEndIndex++;
        if (paperFooterCanntOn.length == 0) {
          findCanntInsertStartIndex = 0;
          findCanntInsertEndIndex = 0;
        }
        t = paperFooterCanntOn.splice(
          findCanntInsertStartIndex,
          findCanntInsertEndIndex - findCanntInsertStartIndex
        );
        if (t.length == 0) {
          paperFooterCanntOn.splice(findCanntInsertStartIndex, 0, {
            top: top,
            bottom: top + height,
          });
        } else {
          paperFooterCanntOn.splice(findCanntInsertStartIndex, 0, {
            top: top > t[0].top ? t[0].top : top,
            bottom:
              top + height > t[t.length - 1].bottom
                ? top + height
                : t[t.length - 1].bottom,
          });
        }

      });

      return paperFooterCanntOn;
    },
    pageSetTop() {
      return this.pageTop;
    },
    pageSetLeft() {
      if (this.paperTypeState == 2) {
        return this.pageLeft + 15.5;
      }
      return this.pageLeft;
    },
    pageSetRight() {
      if (this.paperTypeState == 2) {
        return this.pageRight + 15.5;
      }
      return this.pageRight;
    },
    pageSetBottom() {
      return this.pageBottom;
    },
    maxTableWidth() {
      let maxTableWidth = 0;
      if (this.paperTypeState == 2) {
        maxTableWidth =
          this.paperStyle.width - this.pageLeft - this.pageRight - 31;
      } else {
        maxTableWidth = this.paperStyle.width - this.pageLeft - this.pageRight;
      }
      this.$store.commit("MAXTABLEWIDTH", maxTableWidth * 2.835);

      return maxTableWidth * 2.835;
    },
  },
  methods: {
    test() {
      console.log(JSON.stringify(printHistory.historys[0]));
      // this.hiprintTemplate.print(this.data2);
    },
    getContent() {
      let content = JSON.parse(JSON.stringify(printHistory.historys[0]));
      if (content.panels[0].panelPageRule == "none") {
        content.panels[0].displayTableBottom = null;
        content.panels[0].displayTableTop = null;
        content.panels[0].paperFooter = null;
        content.panels[0].paperHeader = null;
        content.panels[0].paperNumberDisabled = true;
      }
      content.panels[0].realPaperHeader = content.panels[0].paperHeader;
      content.panels[0].realPaperFooter = content.panels[0].paperFooter;
      let tableBottom, tableTop;
      let tableBottomList = [],
        tableTopList = [];
      let tableBottomEstPt = 0; //表格之下，paperFooter之上，最后一个元素底部位置
      let realPaperFooter = content.panels[0].paperFooter;
      //  tableBottom tableTop 删除序号formatter2  修改 多个表格也能都找到 图片格式
      
      for (let printElement of content.panels[0].printElements) {
        if (printElement.printElementType.type == "table") {
          tableBottom = printElement.options.top + printElement.options.height;
          tableTop = printElement.options.top;
          tableBottomList.push(tableBottom);
          tableTopList.push(tableTop);
          for (let column of printElement.options.columns) {
            for (let item of column) {
              item.field = item.columnId;

              if (item.columnId == "seq") {
                item.formatter2 = undefined;
                item.tableTextType = "sequence";
              }
              if (item.columnId == "images") {
                item.formatter2 = undefined;
                item.tableTextType = "image";
              }
              if (item.columnId == "barcode") {
                if (printElement.options.barcode=="barcode") {
                  item.formatter2 = undefined;
                  item.tableTextType = "barcode";
                  item.tableBarcodeMode = "CODE128A";
                } else if (printElement.options.barcode=="qrcode") {
                  item.formatter2 = undefined;
                  item.tableTextType = "qrcode";
                  item.tableBarcodeMode = null;
                } else {
                  item.formatter2 = null;
                  item.tableTextType = null;
                  item.tableBarcodeMode = null;
                }
              }
              
            }
          }
          
          printElement.options.editing = false;
        }
      }
      //元素不能放在表格中
      for (let printElement of content.panels[0].printElements) {
        //元素不能放在表格中
        tableBottomList.forEach((item, index) => {
          tableBottom = item;
          tableTop = tableTopList[index];
          if (
            (printElement.options.top < tableBottom &&
              printElement.options.top + printElement.options.height >
                tableBottom) ||
            (printElement.options.top > tableTop &&
              printElement.options.top + printElement.options.height <
                tableBottom)
          ) {
            printElement.options.top = tableBottom;
            // 提醒用户
            console.log("请将文本放在表格之外，否则打印时可能会出现问题");
            this.$message.error(
              "请将文本放在表格之外，否则打印时可能会出现问题"
            );
          }
        });
      }
      if (content.panels[0].displayTableBottom && tableBottomList.length == 1) {
        // 初始化页尾线
        for (let item of this.paperFooterCanntOn) {
          if (
            content.panels[0].paperFooter > item.top &&
            content.panels[0].paperFooter < item.bottom
          ) {
            content.panels[0].paperFooter = item.bottom;
            break;
          }
          
        }
        content.panels[0].realPaperFooter = content.panels[0].paperFooter;
        realPaperFooter = content.panels[0].paperFooter;
        // 防止表格下方过于分散 tableBottom realPaperFooter
        let qujianList = this.paperFooterCanntOn.filter((item) => {
          return item.top >= tableBottom&&item.bottom<=realPaperFooter;
        })
        let qujianTop =0;
        let qujianBottom =0;
        let lastQujianBottom =0;
        qujianList.forEach((item,index)=>{
          if(index==0){
            lastQujianBottom = item.bottom;
          }else{
            if(item.top-lastQujianBottom>55){
              qujianTop =item.top;
            }
            lastQujianBottom = item.bottom;
          }
        })
        if(qujianTop>0){
          qujianBottom = qujianList[qujianList.length-1].bottom;
          //所有区间内的元素上升50
          if(realPaperFooter- qujianBottom<50){
            for (let printElement of content.panels[0].printElements) {
            if (
              printElement.options.top >= qujianTop && printElement.options.top+printElement.options.height<=qujianBottom
            ){
              printElement.options.top -= 50;
              // 提醒用户给表格预留打印空间
              this.$message.error(
                "请给表格预留打印空间"
              );
            }
            
          }
          }
          
        }

           
        // 尾页页尾线
        // content.panels[0].lastPaperFooter = content.panels[0].paperFooter;

        //tableBottomEstPt
        for (let printElement of content.panels[0].printElements) {
          //元素不能放在表格中
          if (
            (printElement.options.top < tableBottom &&
              printElement.options.top + printElement.options.height >
                tableBottom) ||
            (printElement.options.top > tableTop &&
              printElement.options.top + printElement.options.height <
                tableBottom)
          ) {
            printElement.options.top = tableBottom;
          }
          // 表格下方(页尾线之上)最下面的元素
          if (
            printElement.options.top + printElement.options.height >
              tableBottomEstPt &&
            printElement.options.top + printElement.options.height <
              realPaperFooter && //页尾线之上
            printElement.options.top >= tableBottom
          ) {
            tableBottomEstPt =
              printElement.options.top + printElement.options.height;
          }
        }
        if (tableBottomEstPt == 0) {
          tableBottomEstPt = tableBottom;
        } else {
          //页尾上升 表格下方元素且原页尾上方元素下降

          let goTOPWidth = tableBottomEstPt - tableBottom + 10;
          let goBottomWidth = realPaperFooter - tableBottomEstPt - 10;

          content.panels[0].paperFooter = realPaperFooter - goTOPWidth;

          for (let printElement of content.panels[0].printElements) {
            if (
              printElement.options.top >= tableBottom &&
              printElement.options.top + printElement.options.height <=
                realPaperFooter
            ) {
              printElement.options.top =
                printElement.options.top + goBottomWidth;
              printElement.options.goBottomWidth = goBottomWidth;
            }
          }
        }
      }
      if (content.panels[0].displayTableTop && tableTopList.length >= 1) {
        content.panels[0].realPaperHeader = content.panels[0].paperHeader;
        // 选出最小的
        if (tableBottomList.length > 1) {
          content.panels[0].paperHeader = tableTopList.reduce((a, b) => {
            return Math.min(a, b);
          });
        } else content.panels[0].paperHeader = tableTopList[0];
      }
      // 表格属性还原
      //  增加功能 数量小数位
      content.panels[0].printElements.forEach((printElement, index) => {
        if (printElement.printElementType.type == "table") {
          printElement.options.column =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.column;
          printElement.options.tableCompute1 =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.tableCompute1;
          printElement.options.tableCompute2 =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.tableCompute2;
          printElement.options.computeUpState =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.computeUpState;
          printElement.options.tableComputeNumberState =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.tableComputeNumberState;
          printElement.options.tableStyle =
            printHistory.historys[0].panels[0].printElements[
              index
            ].options.tableStyle;

            printElement.options.columns[0].forEach((item, index) => {
              if (item.field == 'totalPrice' || item.field == 'total') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              } else if (item.field == 'price') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              }else if (item.field == 'totalPriceTax') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              }else if (item.field == 'taxAmount') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              }
              else if (item.field =='priceDef') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              } else if (item.field == 'priceTax') {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return options.littlePoint==-1? _ : (Number(_)?.toFixed(typeof options.littlePoint=='number'?options.littlePoint :2)); }`;
              }   
              else {
                item.formatter2 = `function f(_,row,i,options){  if(options.editing) return '@${item.title}'; return _; }`;
              }
              if (item.field == "quantity") {
                console.log('@@@@@@@@@@@@@@@@options',123);
                item.formatter2 = `function f(_,row,i,options){console.log('@@@@@@@@@@@@@@@@options',options);  if(options.editing) return '@数量'; return (options.quantityLittlePoint==-1||options.quantityLittlePoint==undefined)? _ : (Number(_)?.toFixed(typeof options.quantityLittlePoint=='number'?options.quantityLittlePoint :2)); }`;
              }
              //兼容老打印设计器 为columns[0]添加checked
              item.checked = true;
              //兼容老打印设计器 为需要合集的小票表格添加属性 tableSummaryTitle true tableSummary sum

              if(printElement.options.tableStyle == 'style2'){
                if(content.panels[0].platform){
                  if( item.field == 'totalPrice'||item.field == 'taxAmount'||item.field == 'totalPriceTax'){
                    item.tableSummaryTitle = true;
                    item.tableSummary = 'sum';
                    if(printElement.options.littlePoint == -1){
                      item.tableSummaryNumFormat = undefined;
                    }else if(printElement.options.littlePoint == undefined){
                      item.tableSummaryNumFormat = undefined;
                    }else{
                      item.tableSummaryNumFormat = printElement.options.littlePoint.toString();
                    }
                  }else if(item.field == 'quantity'&&printElement.options.tableComputeNumberState){
    
                    item.tableSummaryTitle = true;
                    item.tableSummary = 'sum';
                    if(printElement.options.quantityLittlePoint == -1||printElement.options.quantityLittlePoint == undefined){
                      item.tableSummaryNumFormat = undefined;
                    }else{
                      item.tableSummaryNumFormat = printElement.options.quantityLittlePoint.toString();
                    }
                  }
                  printElement.options.footerFormatter = undefined;
                }else{
                  if( item.field == 'totalPrice'||item.field == 'taxAmount'||item.field == 'totalPriceTax'){
                    item.tableSummaryNumFormat = undefined;
                  }else if(item.field == 'quantity'&&printElement.options.tableComputeNumberState){
                    item.tableSummaryNumFormat = undefined;
                  }
                }
              }
              
            }) 
            
        }
      });
      let leftleft = 0,
        toptop = 0;
      if (this.paperTypeState == 2) {
        leftleft = (-15.5 + this.MyOffsetX) * 2.835;
        toptop = this.MyOffsetY * 2.835;
      } else {
        leftleft = this.MyOffsetX* 2.835;
        toptop = this.MyOffsetY * 2.835;
      }

      content.panels[0].printElements.forEach((printElement, index) => {
        printElement.options.left += leftleft;
        printElement.options.leftleft = leftleft;
        printElement.options.top += toptop;
        printElement.options.toptop = toptop;
      });
      content.panels[0].paperNumberTop += toptop;
      content.panels[0].paperNumberLeft += leftleft;
      content.panels[0].paperNumberTopTop = toptop;
      content.panels[0].paperNumberLeftLeft = leftleft;
      content.panels[0].paperHeader += toptop;
      content.panels[0].paperFooter += toptop;

      content.panels[0].MyOffsetX = this.MyOffsetX;
      content.panels[0].MyOffsetY = this.MyOffsetY;
      content.panels[0].pageTop = this.pageTop;
      content.panels[0].pageLeft = this.pageLeft;
      content.panels[0].pageRight = this.pageRight;
      content.panels[0].pageBottom = this.pageBottom;


      if (content.panels[0].paperHeader < 0) {
        content.panels[0].paperHeader = this.pageTop * 2.835;
      }
      if (content.panels[0].paperFooter > content.panels[0].height * 2.835) {
        content.panels[0].paperFooter =
          content.panels[0].height * 2.835 - this.pageBottom * 2.835;
      }

      // bug修正 默认自定义纸张
      content.panels[0].paperType = "自定义";
      // bug修正 panels[0].panelPageRule 为"" 导致小票打印不打印元素后的横线
      content.panels[0].panelPageRule = null;
      // bug修正 增加横纵向
      content.panels[0].orient = 2;

      console.log(content);
      return JSON.stringify(content);
    },
    async init() {
      //1s
      initElementTypeProvider(this.printElementTypeGroup);

      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });

      this.hiprintTemplate.design("#PrintContainer");
      window.hiprintTemplate = this.hiprintTemplate;
    },
    // 解析模板
    parseTemplate(template) {
      // 解析模板
      template.panels[0].printElements.forEach((printElement) => {
        if (printElement.printElementType.type == "table") {
          printElement.options.column = JSON.parse(
            JSON.stringify(
              this.column?.[printElement.options.field] ||
                printElement.options.column
            )
          );
          printElement.options.column[0].forEach((item) => {
            //columns存在对象item,  item.checked 设为true
            let find = printElement.options.columns[0].find((columns) => {
              return columns.columnId == item.columnId;
            });
            if (find) {
              item.checked = true;
            }
          });
          printElement.options.footerFormatter = this.footerFormatter;
        }
      });
      return template;
    },
    initTemplate() {
      console.log(this.templateStatus, this.printStatus);
      if (this.templateStatus && this.printStatus == 1) {
        printHistory.clear();
        if (this.template) {
          printHistory.historys.unshift(this.template);
        } else {
          printHistory.historys.unshift(
            this.parseTemplate(
              JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
            )
          );
        }
        //调整初始数据
        //元素位置调整
        for (let printElement of printHistory.historys[0].panels[0]
          .printElements) {
          if (printElement.options.goBottomWidth) {
            printElement.options.top =
              printElement.options.top - printElement.options.goBottomWidth;
            printElement.options.goBottomWidth = null;
          }
        }
        //偏移调整
        let content = printHistory.historys[0];
        content.panels[0].printElements.forEach((printElement, index) => {
          if (printElement.options.leftleft) {
            printElement.options.left -= printElement.options.leftleft;
            printElement.options.leftleft = null;
          }
          if (printElement.options.toptop) {
            printElement.options.top -= printElement.options.toptop;
            printElement.options.toptop = null;
          }
        });
        if (typeof content.panels[0].paperNumberTopTop == "number") {
          content.panels[0].paperNumberTop -=
            content.panels[0].paperNumberTopTop;
          content.panels[0].paperNumberTopTop = null;
        }
        if (typeof content.panels[0].paperNumberLeftLeft == "number") {
          content.panels[0].paperNumberLeft -=
            content.panels[0].paperNumberLeftLeft;
          content.panels[0].paperNumberLeftLeft = null;
        }
        let { MyOffsetX, MyOffsetY, pageTop, pageLeft, pageRight, pageBottom } =
          content.panels[0];
        this.$store.commit("PIANYI", {
          MyOffsetX,
          MyOffsetY,
          pageTop,
          pageLeft,
          pageRight,
          pageBottom,
        });
        if (typeof MyOffsetX != "number") {
          content.panels[0].MyOffsetX = this.MyOffsetX;
        }
        if (typeof MyOffsetY != "number") {
          content.panels[0].MyOffsetY = this.MyOffsetY;
        }
        if (typeof pageTop != "number") {
          content.panels[0].pageTop = this.pageTop;
        }
        if (typeof pageLeft != "number") {
          content.panels[0].pageLeft = this.pageLeft;
        }
        if (typeof pageRight != "number") {
          content.panels[0].pageRight = this.pageRight;
        }
        if (typeof pageBottom != "number") {
          content.panels[0].pageBottom = this.pageBottom;
        }

        // 初始化 paperHeader paperFooter
        // #region
        if (
          typeof printHistory.historys[0].panels[0].realPaperHeader == "number"
        ) {
          printHistory.historys[0].panels[0].paperHeader =
            printHistory.historys[0].panels[0].realPaperHeader;
        }
        if (
          typeof printHistory.historys[0].panels[0].realPaperFooter == "number"
        ) {
          printHistory.historys[0].panels[0].paperFooter =
            printHistory.historys[0].panels[0].realPaperFooter;
        }
        // #endregion
        // 表格列循环 seq的 formatter2
        for (let printElement of printHistory.historys[0].panels[0]
          .printElements) {
          if (printElement.printElementType.type == "table") {
            for (let column of printElement.options.columns) {
              for (let item of column) {
                if (item.columnId == "seq") {
                  item.formatter2 = "function f(a,b,i){ return i + 1 }";
                }
                if (item.columnId == "images") {
                  item.formatter2 =
                    "function f(_,row,i,options){  if(options.editing) return '@图片'; return _; }";
                }
                if (item.columnId == "barcode") {
                  item.formatter2 =
                    "function f(_,row,i,options){  if(options.editing) return '@条码'; return _; }";
                }
              }
            }
            printElement.options.editing = true;
          }
        }

        //配置初始化属性
        this.setDataByTemplate();

        this.init();
        printHistory.init0(this.hiprintTemplate);
      }
    },
    initTemplate0() {
      this.setDataByTemplate();
      // 清空页面
      this.$refs.printContainer.innerHTML = "";
      console.log(printHistory.historys[0]);
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });

      this.hiprintTemplate.design("#PrintContainer");
      window.hiprintTemplate = this.hiprintTemplate;
    },
    setDataByTemplate() {
      this.paperStyle.width = printHistory.historys[0].panels[0].width;
      this.paperStyle.height = printHistory.historys[0].panels[0].height;
      //是否为自定义
      let token = 1;
      for (let paperType of this.paperTypeList) {
        if (
          (this.paperStyle.width == paperType.width &&
            this.paperStyle.height == paperType.height) ||
          //是否为小票
          ((this.paperStyle.width == 110 ||
            this.paperStyle.width == 80 ||
            this.paperStyle.width == 76 ||
            this.paperStyle.width == 58) &&
            this.paperStyle.height == 10 &&
            this.paperStyle.width == paperType.width)
        ) {
          this.paperStyle.width = paperType.width;
          this.paperStyle.height = paperType.height;
          printHistory.historys[0].panels[0].width = paperType.width;
          printHistory.historys[0].panels[0].height = paperType.height;
          this.paperType = paperType.name;
          this.receipt = paperType.receipt;
          this.paperTypeState = paperType.paperTypeState;

          token = 0;
          // 初始化 template2 和template3

          break;
        }
      }

      if (token) {
        this.paperType = "自定义";

        this.paperTypeState = 4;
      }
    },
    changePaperType() {
      const paperType = this.paperTypeList.find(
        (item) => item.name === this.paperType
      );
      // 高度变化 新-旧
      let goBottomWidth =
        (paperType.height || this.paperStyle.height) - this.paperStyle.height;
      //修改dom显示
      this.paperStyle.width = paperType.width || this.paperStyle.width;
      this.paperStyle.height = paperType.height || this.paperStyle.height;
      this.receipt = paperType.receipt || this.receipt;
      // 新的历史
      printHistory.historys.unshift(
        JSON.parse(JSON.stringify(printHistory.historys[0]))
      );
      let panel = printHistory.historys[0].panels[0];

      // 根据变化设定新页面的属性
      if (this.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/label") {
        printHistory.historys.shift();
        //存的模板是二等分
        if (paperType.paperTypeState == 2) {
          printHistory.historys.unshift(
            this.parseTemplate(
              JSON.parse(JSON.stringify(templates[this.sourceUrl][1]))
            )
          );
        } else {
          printHistory.historys.unshift(
            this.parseTemplate(
              JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
            )
          );
        }

        panel = printHistory.historys[0].panels[0];
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        panel.paperFooter = panel.height * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
        panel.panelPageRule = null;
        panel.paperNumberDisabled = true;
        panel.displayTableTop = false;
        panel.displayTableBottom = false;
      } else if (paperType.paperTypeState == 2 && this.paperTypeState == 1) {
        /* A4 变 等分纸张 */
        // 整体右移
        panel.printElements.forEach((item) => {
          item.options.left = item.options.left + 45;
        });
        panel.paperNumberLeft = panel.paperNumberLeft + 45;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;

        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
      } else if (paperType.paperTypeState == 1 && this.paperTypeState == 2) {
        /* 等分变A4 */
        // 整体左移
        panel.printElements.forEach((item) => {
          item.options.left = item.options.left - 45;
        });
        panel.paperNumberLeft = panel.paperNumberLeft - 45;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
      } else if (paperType.paperTypeState == 2 && this.paperTypeState != 2) {
        /** 非等分变等分 */
        // 不需要左右移动
        // 弹出之前加的历史并切换
        printHistory.historys.shift();
        //存的模板是二等分
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        goBottomWidth = paperType.height - 140;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;

        panel.displayTableTop = true;
        panel.displayTableBottom = true;
      } else if (paperType.paperTypeState == 3 && this.paperTypeState != 3) {
        /** 非小票变小票 */
        // 不需要左右移动
        // 弹出之前加的历史并切换
        printHistory.historys.shift();
        //存的模板是二等分
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][1]))
          )
        );
        panel = printHistory.historys[0].panels[0];

        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化

        panel.paperFooter = panel.height * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
        //右侧属性
        panel.panelPageRule = "none";
        panel.paperNumberDisabled = true;
        // 页边距
        this.$store.state.pageLeft = 4;
        this.$store.state.pageRight = 4;
      } else if (paperType.paperTypeState == 1 && this.paperTypeState != 1) {
        /** 非A4变A4 */
        // 弹出之前加的历史并切换
        printHistory.historys.shift();
        //存的模板是二等分
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        goBottomWidth = paperType.height - 140;

        // 整体左移
        panel.printElements.forEach((item) => {
          item.options.left = item.options.left - 45;
        });
        panel.paperNumberLeft = panel.paperNumberLeft - 45;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
        //右侧属性
        panel.displayTableTop = true;
        panel.displayTableBottom = true;
        // console.log("123456");
      } else if (paperType.paperTypeState == this.paperTypeState) {
        /** 纸张类型无变化 */
        // 不需要左右移动
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;
        // 纸张类型改变
        this.paperTypeState = paperType.paperTypeState;
      } else {
        // 变自定义
        this.paperTypeState = paperType.paperTypeState;
      }
      //清空页面
      this.$refs.printContainer.innerText = "";
      //更新页面
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });
      window.hiprintTemplate = this.hiprintTemplate;
      this.hiprintTemplate.design("#PrintContainer");
      printHistory.init0();
    },
    changePaperStyle() {
      printHistory.historys.unshift(
        JSON.parse(JSON.stringify(printHistory.historys[0]))
      );
      printHistory.historys[0].panels[0].width = this.paperStyle.width;
      printHistory.historys[0].panels[0].height = this.paperStyle.height;
      this.$refs.printContainer.innerText = "";
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });
      window.hiprintTemplate = this.hiprintTemplate;
      this.hiprintTemplate.design("#PrintContainer");
    },
    // 撤销
    undo() {
      if (printHistory.undo()) {
        this.$refs.printContainer.innerText = "";
        this.setDataByTemplate();
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        this.hiprintTemplate.design("#PrintContainer");
        window.hiprintTemplate = this.hiprintTemplate;
      }
    },
    // 恢复
    redo() {
      if (printHistory.redo()) {
        this.$refs.printContainer.innerText = "";
        this.setDataByTemplate();
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        this.hiprintTemplate.design("#PrintContainer");
        window.hiprintTemplate = this.hiprintTemplate;
      }
    },

    deleteElement() {
      if (this.elementSetting.selectedBasePrintElement) {
        this.hiprintTemplate.deletePrintElement(
          this.elementSetting.selectedBasePrintElement
        );
        printHistory.addHistory(this.hiprintTemplate);
      } else if (this.elementSetting.selectedTablePrintElement) {
        this.hiprintTemplate.deletePrintElement(
          this.elementSetting.selectedTablePrintElement
        );
        printHistory.addHistory(this.hiprintTemplate);
      } else {
        this.hiprintTemplate.editingPanel.mouseRect.mouseRectSelectedElement.forEach(
          (item) => {
            this.hiprintTemplate.deletePrintElement(item);
          }
        );
        printHistory.addHistory(this.hiprintTemplate);
      }
    },
    newTemplate() {
      let newTem = this.hiprintTemplate.getJson();
      console.log("newTem");
      newTem.panels[0].paperHeader =
        printHistory.historys[0].panels[0].paperHeader;
      newTem.panels[0].panelPageRule =
        printHistory.historys[0].panels[0].panelPageRule;
      newTem.panels[0].platform =
        printHistory.historys[0].panels[0].platform;
      newTem.panels[0].displayTableTop =
        printHistory.historys[0].panels[0].displayTableTop;
      newTem.panels[0].displayTableBottom =
        printHistory.historys[0].panels[0].displayTableBottom;
      newTem.panels[0].realPaperHeader =
        printHistory.historys[0].panels[0].realPaperHeader;
      newTem.panels[0].realPaperFooter =
        printHistory.historys[0].panels[0].realPaperFooter;

      newTem.panels[0].MyOffsetX = printHistory.historys[0].panels[0].MyOffsetX;
      newTem.panels[0].MyOffsetY = printHistory.historys[0].panels[0].MyOffsetY;
      newTem.panels[0].pageTop = printHistory.historys[0].panels[0].pageTop;
      newTem.panels[0].pageBottom =
        printHistory.historys[0].panels[0].pageBottom;
      newTem.panels[0].pageLeft = printHistory.historys[0].panels[0].pageLeft;
      newTem.panels[0].pageRight = printHistory.historys[0].panels[0].pageRight;

      newTem.panels[0].printElements.forEach((printElement, index) => {
        if (printElement.printElementType.type == "table") {
          let editTable =
            printHistory.historys[0].panels[0].printElements[index];
          console.log(editTable);
          printElement.options.column = editTable?.options?.column;
          printElement.options.tableCompute1 =
            editTable?.options?.tableCompute1;
          printElement.options.tableCompute2 =
            editTable?.options?.tableCompute2;

          printElement.options.computeUpState =
            editTable?.options?.computeUpState;
          printElement.options.tableComputeNumberState =
            editTable?.options?.tableComputeNumberState;
          printElement.options.tableStyle = editTable?.options?.tableStyle;
          printElement.options.editing = true;
        }
      });
      return newTem;
    },
  },
  watch: {
    printStatus() {
      this.initTemplate();
    },
    templateStatus() {
      this.initTemplate();
    },
    // pageLeft () {
    //   this.handleMaxTableWidth()
    // },
    // pageRight () {
    //   this.handleMaxTableWidth()
    // },
  },
  mounted() {
    //按住delete键删除元素
    document.addEventListener("keydown", (e) => {
      if (e.key === "Delete") {
        this.deleteElement();
      }
    });
    // 按ctrl + z 撤销
    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.code == "KeyZ") {
        this.undo();
      }
    });
    // 按ctrl + y 恢复
    document.addEventListener("keydown", (e) => {
      if (e.ctrlKey && e.code == "KeyY") {
        this.redo();
      }
    });
    this.$bus.$on("undo", () => {
      this.undo();
    });
    this.$bus.$on("redo", () => {
      this.redo();
    });
    this.$bus.$on("changePaperHeader", (paperHeader) => {
      this.hiprintTemplate.editingPanel.designPaper.paperHeader = paperHeader;
      this.hiprintTemplate.editingPanel.designPaper.triggerOnPaperBaseInfoChanged();
      this.hiprintTemplate.design("#PrintContainer");
    });
    this.$bus.$on("changePaperFooter", (paperFooter) => {
      for (let item of this.paperFooterCanntOn) {
        if (paperFooter > item.top && paperFooter < item.bottom) {
          paperFooter = item.bottom;
          break;
        }
      }
      printHistory.historys.unshift(
        JSON.parse(JSON.stringify(printHistory.historys[0]))
      );
      printHistory.historys[0].panels[0].paperFooter = paperFooter;
      this.$refs.printContainer.innerText = "";
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });
      window.hiprintTemplate = this.hiprintTemplate;
      this.hiprintTemplate.design("#PrintContainer");
    });
    this.$bus.$on("changePaperNumberDisabled", (paperNumberDisabled) => {
      this.hiprintTemplate.editingPanel.designPaper.paperNumberDisabled =
        paperNumberDisabled;
      this.hiprintTemplate.editingPanel.designPaper.triggerOnPaperBaseInfoChanged();
      this.hiprintTemplate.design("#PrintContainer");
    });
    
    this.$bus.$on("changePaperNumberFormat", (paperNumberFormat) => {
      this.hiprintTemplate.editingPanel.designPaper.paperNumberFormat =
        paperNumberFormat;
      this.hiprintTemplate.editingPanel.designPaper.triggerOnPaperBaseInfoChanged();
      this.hiprintTemplate.design("#PrintContainer");
    });
    this.$bus.$on("changePanelDisplayTableTop", (displayTableTop) => {
      let newTem = this.newTemplate();
      newTem.panels[0].displayTableTop = displayTableTop;
      printHistory.historys.unshift(newTem);
    });
    this.$bus.$on("changePanelDisplayTableBottom", (displayTableBottom) => {
      let newTem = this.newTemplate();
      newTem.panels[0].displayTableBottom = displayTableBottom;
      printHistory.historys.unshift(newTem);
    });
    this.$bus.$on("changePanelPageRule", (panelPageRule) => {
      let newTem = this.newTemplate();
      newTem.panels[0].panelPageRule = panelPageRule;

      printHistory.historys.unshift(newTem);
    });
    this.$bus.$on("changePlatform", (platform) => {
      let newTem = this.newTemplate();
      newTem.panels[0].platform = platform;
      printHistory.historys.unshift(newTem);
    });
    
    this.$bus.$on("save", async () => {
      let content = this.getContent();
      let id = this.$store.getters.templateId;
      let res = await updateTemplateContentById({
        content,
        id,
      });
      if (res.code == 200 && res.flag) {
        this.$message.success("保存模板成功");
      } else {
        this.$message.error(res.message || res.title || "保存模板失败");
      }
    });
    this.$bus.$on("design", () => {
      this.hiprintTemplate.design("#PrintContainer");
    });
    this.$bus.$on("design2", () => {
      this.$refs.printContainer.innerText = "";
      this.hiprintTemplate = new hiprint.PrintTemplate({
        template: printHistory.historys[0],
        settingContainer: "#none",
      });
      window.hiprintTemplate = this.hiprintTemplate;
      this.hiprintTemplate.design("#PrintContainer");
    });
    this.$bus.$on("useTemplate", () => {
      let panel, goBottomWidth;
      this.$store.state.pageLeft = 5;
      this.$store.state.pageRight = 5;
      if (this.sourceUrl == "/hiPrint/getHiPrintResourceByCatId/label") {
        this.$store.state.pageLeft = 1;
        this.$store.state.pageRight = 0;
        this.paperType = "自定义";
        this.paperTypeState = 4;
        this.receipt = false;
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        // 新的长宽
        this.paperStyle.width = panel.width;
        this.paperStyle.height = panel.height;

        this.$refs.printContainer.innerText = "";
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        window.hiprintTemplate = this.hiprintTemplate;
        this.hiprintTemplate.design("#PrintContainer");
      } else if (
        (this.paperTypeState == 2 || this.paperTypeState == 4) &&
        !!templates[this.sourceUrl]?.[0]
      ) {
        // 为4时候需要初始化面板 二等分
        if (this.paperTypeState == 4) {
          this.paperStyle.width = 241;
          this.paperStyle.height = 140;
          this.paperType = "二等分";
          this.paperTypeState = 2;
          this.receipt = false;
        }
        //
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        goBottomWidth = this.paperStyle.height - 140;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;

        this.$refs.printContainer.innerText = "";
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        window.hiprintTemplate = this.hiprintTemplate;
        this.hiprintTemplate.design("#PrintContainer");
      } else if (this.paperTypeState == 1 && !!templates[this.sourceUrl]?.[0]) {
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][0]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        goBottomWidth = this.paperStyle.height - 140;

        // 整体左移
        panel.printElements.forEach((item) => {
          item.options.left = item.options.left - 45;
        });
        panel.paperNumberLeft = panel.paperNumberLeft - 45;
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        // paperFooter 以及下面的元素下降 小票和等分之间互换无效
        panel.printElements.forEach((item) => {
          if (item.options.top >= panel.paperFooter) {
            item.options.top = item.options.top + goBottomWidth * 2.835;
          }
        });
        // 页码在页脚之下也需要移动
        if (panel.paperNumberTop >= panel.paperFooter) {
          panel.paperNumberTop = panel.paperNumberTop + goBottomWidth * 2.835;
        }
        panel.paperFooter = panel.paperFooter + goBottomWidth * 2.835;

        this.$refs.printContainer.innerText = "";
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        window.hiprintTemplate = this.hiprintTemplate;
        this.hiprintTemplate.design("#PrintContainer");
      } else if (this.paperTypeState == 3 && !!templates[this.sourceUrl]?.[1]) {
        printHistory.historys.unshift(
          this.parseTemplate(
            JSON.parse(JSON.stringify(templates[this.sourceUrl][1]))
          )
        );
        panel = printHistory.historys[0].panels[0];
        // 新的长宽
        panel.width = this.paperStyle.width;
        panel.height = this.paperStyle.height;
        // 页脚变化
        panel.paperFooter = panel.height * 2.835;
        // 前两个element宽度
        panel.printElements.forEach((item, index) => {
          if (index < 2) {
            item.options.width = panel.width * 2.835;
          }
          if (item.printElementType.type == "table") {
            item.options.width = (panel.width - 8) * 2.835;
          }
        });
        // 页边距
        this.$store.state.pageLeft = 4;
        this.$store.state.pageRight = 4;

        this.$refs.printContainer.innerText = "";
        this.hiprintTemplate = new hiprint.PrintTemplate({
          template: printHistory.historys[0],
          settingContainer: "#none",
        });
        window.hiprintTemplate = this.hiprintTemplate;
        this.hiprintTemplate.design("#PrintContainer");
      }
    });
    this.$bus.$on("setting", () => {
      this.setting = true;
    });
    this.$bus.$on("addHistory", (force) => {
      printHistory.addHistory(this.hiprintTemplate, force);
    });
    this.$bus.$on("getidIndex", (id) => {
      console.log("id", id);
      let index = this.hiprintTemplate.editingPanel.printElements.findIndex(
        (item) => {
          return item.id == id;
        }
      );

      this.$bus.$emit("index", index);
    });
    this.$bus.$on("getidIndexByEditing", () => {
      
      let index = this.hiprintTemplate.editingPanel.printElements.findIndex(
        (item) => {
          return item.options.isEditing;
        }
      );

      this.$bus.$emit("index", index);
    });
    this.$bus.$on("getHiprintTemplate", () => {
      this.$bus.$emit("hiprintTemplate", this.hiprintTemplate);
    });
    this.$bus.$on("deleteElement", () => {
      this.deleteElement();
      
    })
    this.$bus.$on("handleImport", (history) => {
      printHistory.historys.unshift(history);
      this.initTemplate0();
    })
    this.$bus.$on("handleExport", () => {
      const jsonData = JSON.stringify(printHistory.historys[0], null, 2);
      const blob = new Blob([jsonData], { type: 'application/json' });
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob);
      a.download = 'template.json';
      a.click();
      URL.revokeObjectURL(a.href);
    })
  },
};
</script>
<style scoped>
.paper-container {
  position: relative;
  margin: auto;
}
#PrintContainer {
  margin: auto;
  text-align: center;
  background: #fff;
  position: relative;
}
>>> .paperType2
  div.design.hiprint-printPaper.hidroppable
  .hiprint-printPaper-content::before {
  content: "";
  display: inline-block;
  width: 49px;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: #d8dbe3;
  background-image: url(~@/assets/images/left.png);
  z-index: 1;
  vertical-align: middle;
}
>>> .paperType2
  div.design.hiprint-printPaper.hidroppable
  .hiprint-printPaper-content::after {
  content: "";
  display: inline-block;
  width: 49px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  background-color: #d8dbe3;
  background-image: url(~@/assets/images/right.png);
  z-index: 1;
  vertical-align: middle;
}
>>> div.design.hiprint-printPaper.hidroppable .hiprint-printPaper-content {
  height: 100%;
  z-index: 1;
}
>>> .hiprint-printElement {
  z-index: 2;
}
>>> div.design.hiprint-printPaper.hidroppable {
  background: #fff;
}
/* 隐藏坐标轴 */
>>> .hiprint_rul_wrapper {
  display: none;
}
/* 隐藏页数 */
/* >>> .hiprint-paperNumber {
  display: none;
} */
/* 表格拖拽样式 */
>>> .design .hiprint-printElement-table-handle {
  width: 100% !important;
  height: 6pt !important;
  top: -3pt !important;
  background-color: transparent !important;
}
/* >>> .hiprint-printElement-table .resizebtn {
  display: none;
} */
>>> .hiprint-headerLine:hover::before {
  content: "页眉线";
  position: absolute;
  top: -16px;
  color: red;
}
>>> .hiprint-headerLine:hover {
  /* 边框颜色 */
  border-color: red !important;
  /* 边框粗细 */
  border-width: 3px !important;
  z-index: 9999 !important;
}
>>> .hiprint-footerLine:hover::before {
  content: "页脚线";
  position: absolute;
  top: -16px;
  color: red;
}
>>> .hiprint-footerLine:hover {
  /* 边框颜色 */
  border-color: red !important;
  /* 边框粗细 */
  border-width: 3px !important;
  z-index: 9999 !important;
}
</style>
<style lang="less" scoped>
.box {
  margin: 20px 50px;
  padding-top: 50px;
}
.paper-type-container {
  //字体无法选中
  user-select: none;
  margin-bottom: 20px;
  text-align: center;
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  .width-height-input {
    width: 50px;
    height: 25px;
    //选中样式清空
    outline: none;
    //value居中
    text-align: center;
    
  }
}
.mask::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: transparent;
  // background-color: rgba(0, 0, 0, 0.3);
  z-index: 999;
  top: 0;
  left: 0;
}
.left-line {
  position: absolute;
  width: 0px;
  height: 100%;

  z-index: 999;
  top: 0;

  border-right: 1px dashed rgba(170, 170, 170, 0.7);
}
.right-line {
  position: absolute;
  width: 0px;
  height: 100%;
  z-index: 999;
  top: 0;
  border-left: 1px dashed rgba(170, 170, 170, 0.7);
}

.top-line {
  position: absolute;
  width: 100%;
  height: 0px;
  z-index: 999;
  top: 3mm;
  border-bottom: 1px dashed rgba(170, 170, 170, 0.7);
}
.bottom-line {
  position: absolute;
  width: 100%;
  height: 0px;
  z-index: 999;
  bottom: 3mm;
  border-top: 1px dashed rgba(170, 170, 170, 0.7);
}
.paperTypeOther .left-line {
  left: 5mm;
}
.paperTypeOther .right-line {
  right: 5mm;
}
.paperTypeOther .left-line {
  left: 20.5mm;
}
.ppaperTypeOther .right-line {
  right: 20.5mm;
}
</style>
  